import { HttpClient } from "@angular/common/http";
import {
    AfterViewChecked,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { Observable, of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { environment } from "@environments/environment";

export interface GraphResponse {
    value: any[];
}

export interface SimpleGroup {
    displayName: string;
    id: string;
    description: string;
}

@Component({
    selector: "ad-group-picker",
    templateUrl: "./ad-group-picker.component.html",
    styleUrls: ["./ad-group-picker.component.scss"],
})
export class AdGroupPickerComponent implements OnInit, AfterViewChecked {
    @Input() Label: string;
    InputControl: FormControl = new FormControl("");
    @Input() TagControl: FormControl;

    constructor(private http: HttpClient) {}

    ngOnInit() {
        this.matches = this.InputControl.valueChanges.pipe(
            map((text) => (typeof text === "string" ? text.trim() : "")),
            map((trimmedText) => ({
                text: trimmedText,
                url: `${environment.udfApiUrl}/api/GraphApiSearch/Groups?search=${trimmedText}`,
            })),
            switchMap((req) => {
                if (req.text) {
                    let res = this.http.get<GraphResponse>(req.url);
                    return res;
                } else {
                    let def: GraphResponse = { value: [] };
                    return of(def);
                }
            }),
            map((graphResponse) =>
                graphResponse.value.map((v) => v as SimpleGroup),
            ),
        );
    }

    ngAfterViewChecked(): void {
        this.MatAutocompleteTrigger.optionSelections
            .pipe(
                tap((selection) => this.add(selection.source.value)),
                tap(
                    (selection) =>
                        (this.adGroupPickerInput.nativeElement.value = ""),
                ),
            )
            .subscribe();
    }

    @ViewChild(MatAutocompleteTrigger, { static: false })
    MatAutocompleteTrigger: MatAutocompleteTrigger;
    @ViewChild("adGroupPickerInput", { static: false })
    adGroupPickerInput: ElementRef<HTMLInputElement>;

    matches: Observable<SimpleGroup[]> = of([]);
    selectedGroups: SimpleGroup[] = [];
    visible = true;
    selectable = true;
    removable = true;

    baseUrl = "https://graph.microsoft.com/v1.0/groups";

    displayFn(group: SimpleGroup): string {
        return group ? group.displayName : "";
    }

    remove(group: SimpleGroup): void {
        const index = this.selectedGroups.findIndex((g) => g.id === group.id);

        if (index >= 0) {
            this.selectedGroups.splice(index, 1);
            this.TagControl.setValue(this.selectedGroups);
        }
    }

    add(group: SimpleGroup): void {
        if (!this.selectedGroups.find((g) => g.id === group.id)) {
            this.selectedGroups.push(group);
            this.TagControl.setValue(this.selectedGroups);
            this.InputControl.setValue("");
        }
    }
}
